// @ts-nocheck
import { del, doesNotHaveExpand, get, post } from "@insite/client-framework/Services/ApiService";
import { GetQuotesApiParameter } from "@insite/client-framework/Services/QuoteService";
import { QuoteCollectionModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";
import { QuoteLineAdditionalInformationModel } from "@store/Framework/Types/ApiModels";

export interface QuoteLastModifedParameter {
    CustomerOrderId: string;
    QuoteLineIds: string[];
}
export interface GetQuotePdfPrintParameter {
    quoteId: string;
    canShowPrice: boolean;
    orderNumber: string;
}
export interface RfqDetailsDocumentParameter {
    orderNumber: string;
    documentName: string;
}
export interface RemoveRfqDetailsDocumentParameter extends RfqDetailsDocumentParameter {
    onSuccess: () => void;
}
export interface StoreGetQuotesApiParameter extends GetQuotesApiParameter {
    name?: string;
    sku?: string;
    initiatedBy?: string;
}
export interface QuoteAdditionalInfoParameter {
    quoteLineId: string;
}

export interface QuoteLineAdditionalInformationParameter {
    CalculationMethod1?: string;
    Percent1?: number;
    CalculationMethod2?: string;
    Percent2?: number;
    CalculationMethod3?: string;
    Percent3?: number;
    CalculationMethod4?: string;
    Percent4?: number;
    CalculationMethod5?: string;
    Percent5?: number;
    CalculationMethod6?: string;
    Percent6?: number;
    CalculationMethod7?: string;
    Percent7?: number;
    CalculationMethod8?: string;
    Percent8?: number;
    CalculationMethod9?: string;
    Percent9?: number;
    CalculationMethod10?: string;
    Percent10?: number;
    CalculationMethod11?: string;
    Percent11?: number;
    OrderLineId?: string;
}

const quotesUri = "/api/v1/quotes";
const serviceUri = "/api/v1/quotes/quotelines/store";
const documentServiceUri = "/api/v1/quote/store";

export async function storeGetQuotes(getQuotesParameter: StoreGetQuotesApiParameter) {
    const quotes = await get<QuoteCollectionModel>(quotesUri, getQuotesParameter);
    cleanQuoteCollection(quotes, getQuotesParameter);
    quotes.quotes?.forEach(cleanQuote);
    return quotes;
}

function cleanQuote(quote: QuoteModel) {
    quote.orderDate = quote.orderDate ? new Date(quote.orderDate) : null;
    quote.expirationDate = quote.expirationDate ? new Date(quote.expirationDate) : null;
    quote.cartLines = quote.quoteLineCollection;
    quote.messageCollection?.forEach(message => {
        if (message.createdDate) {
            message.createdDate = new Date(message.createdDate);
        }
    });
}

function cleanQuoteCollection(quoteCollection: QuoteCollectionModel, parameter?: { expand?: string[] }) {
    if (doesNotHaveExpand(parameter, "salesList")) {
        quoteCollection.salespersonList = null;
    }
}

export async function getQuoteLastModifiedInfo(quoteLastModifedParameter: QuoteLastModifedParameter) {
    const quoteLastModifiedOn = await get<any>(
        `${serviceUri}/getquotelastmodifiedOn?CustomerOrderId=${quoteLastModifedParameter.CustomerOrderId}&QuoteLineIds=${quoteLastModifedParameter.QuoteLineIds}`,
    );
    return quoteLastModifiedOn;
}

export async function getQuoteLineAdditionalInfo(quoteAdditionalInfoParameter: QuoteAdditionalInfoParameter) {
    const quoteLineAdditionalInfo = await get<any>(
        `${serviceUri}/getadditionalinformation/${quoteAdditionalInfoParameter.quoteLineId}`,
    );
    return quoteLineAdditionalInfo;
}

export async function saveAdditionalInformation(quoteInfo: QuoteLineAdditionalInformationParameter) {
    const result = await post(`${serviceUri}/saveadditionalinformation/`, quoteInfo);
    return result;
}

export function getPdfPrint(getQuotePdfPrintParameter: GetQuotePdfPrintParameter) {
    const uri = `${documentServiceUri}/getpdfprint/${getQuotePdfPrintParameter.quoteId}/${getQuotePdfPrintParameter.canShowPrice}`;
    window.open(uri, "_blank");
}

export async function getDocumentList(orderNumber: string) {
    const documentList = await get<string[]>(`${documentServiceUri}/getquotedocumentlist/${orderNumber}`);
    return documentList;
}

export function getDocument(getRfqDetailsDocumentParameter: RfqDetailsDocumentParameter) {
    const uri = `${documentServiceUri}/getquotedocument/${getRfqDetailsDocumentParameter.orderNumber}?documentname=${getRfqDetailsDocumentParameter.documentName}`;
    window.open(uri, "_blank");
}

export async function removeDocument(removeRfqDetailsDocumentParameter: RfqDetailsDocumentParameter) {
    const uri = `${documentServiceUri}/deletequotedocument/${removeRfqDetailsDocumentParameter.orderNumber}?documentname=${removeRfqDetailsDocumentParameter.documentName}`;
    try {
        await del(uri);
        return true;
    } catch (error) {
        return false;
    }
}

export async function setDocument(fileData: any) {
    const uri = `${documentServiceUri}/postquotedocument/`;

    try {
        const fileResponse = await post<any>(uri, fileData);
        if (fileResponse) {
            return fileResponse;
        }
        return false;
    } catch (error) {
        return false;
    }
}
